import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition, StateService } from '@uirouter/core';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    AdminPerformanceProfilesComponent,
} from '@client/app/feature-modules/admin/modules/admin-performance-profiles/components/admin-performance-profiles/admin-performance-profiles.component';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import { AdminAddEditPerformanceProfileComponent } from '../components/admin-add-edit-perfrmance-profile/admin-add-edit-performance-profile.component';
import { Injectable } from '@angular/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Injectable({ providedIn: 'root' })
export class PerformanceProfilesAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('admin_page_performance')) {
            return true;
        }
        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}

export const AdminPerformanceProfilesStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.performance-profiles',
        url: '/performance-profiles?page_size&page&archived',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
            archived: {
                dynamic: true,
                value: 'false',
            },
        },
        redirectTo: (transition: Transition) => {
            const redirectParams = {
                state: 'base.customer.admin.performance-profiles',
                params: {
                    ...transition.params(),
                },
            };

            const params = transition.params();
            const { archived } = params;
            if (!['true', 'false'].includes(archived)) {
                redirectParams.params.archived = 'false';
            }

            const paginationRedirectParams = paginationUrlQueryParamsValidator('base.customer.admin.performance-profiles')(transition);

            if (paginationRedirectParams) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                redirectParams.params.page_size = paginationRedirectParams.params.page_size;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                redirectParams.params.page = paginationRedirectParams.params.page;
            }

            if (
                redirectParams.params.archived !== params.archived ||
                redirectParams.params.page_size !== params.page_size ||
                redirectParams.params.page !== params.page
            ) {
                return redirectParams;
            }
            return undefined;
        },
        resolve: [
            {
                token: 'performanceProfilesAccess',
                deps: [PerformanceProfilesAccessGuard, Transition],
                resolveFn: (guard: PerformanceProfilesAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
        component: AdminPerformanceProfilesComponent,
        data: { title: 'Acquia Web Governance - Performance Profiles' },
    },
    {
        name: 'base.customer.admin.performance-profile-form',
        url: '/performance-profile-form/{id}',
        params: {
            id: {
                squash: true,
                value: null,
            },
        },
        resolve: [
            {
                token: 'performanceProfilesAccess',
                deps: [PerformanceProfilesAccessGuard, Transition],
                resolveFn: (guard: PerformanceProfilesAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
        component: AdminAddEditPerformanceProfileComponent,
        data: { title: 'Acquia Web Governance - Performance Profile Form' },
    },
];
